/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React, {useEffect, useState} from 'react';
import { Bar } from 'react-chartjs-2';
import {Link} from "react-router-dom";
import axios from "axios";
import BASEURL from "./../../Constants";

const Home = () => {

    const [report, setReport] = useState([])
    const getReport = () =>{
        const token = localStorage.admin_token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        axios.post(BASEURL+'/api/dashboard/get-dashboard-data').then(res=>{
            setReport(res.data)
        })
    }
    useEffect(() => {
        getReport()
    }, []);


    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Dashboard</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">Dashboard</li>
                </ol>
                <div className="my-card text-center">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="card bg-primary text-white">
                                                <div className="card-header">
                                                    <h5>Total Order Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_order_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Total Paid Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_paid_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-warning text-white">
                                                <div className="card-header">
                                                    <h5>Total Due Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_due_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4 mb-5">
                                        <div className="col-md-3">
                                            <div className="card bg-info text-white">
                                                <div className="card-header">
                                                    <h5>Total Order</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="card bg-dark text-white">
                                                <div className="card-header">
                                                    <h5>Pending</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.pending_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Processing</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.processing_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="card bg-danger text-white">
                                                <div className="card-header">
                                                    <h5>Canceled</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.canceled_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Delivered Order</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.delivered_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="row mt-5 pb-5">*/}
                                    {/*    <div className="col-md-6">*/}
                                    {/*        <Bar*/}
                                    {/*            data={data}*/}
                                    {/*            width={50}*/}
                                    {/*            height={50}*/}
                                    {/*            options={{ maintainAspectRatio: true }}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col-md-6">*/}
                                    {/*        <Bar*/}
                                    {/*            data={data}*/}
                                    {/*            width={50}*/}
                                    {/*            height={50}*/}
                                    {/*            options={{ maintainAspectRatio: true }}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
export default Home